// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../../domain/helpers/AuthUtils.mjs";
import * as CityContext$PorterinFeature from "../../../../../../contexts/city-context/CityContext.mjs";
import * as AuthInputCmp$PorterinFeature from "../../common/AuthInputCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../../../../shared/core/helpers/CommonHelper.mjs";
import * as AuthButtonCmp$PorterinFeature from "../../common/AuthButtonCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as AddressContext$PorterinFeature from "../../../../../../contexts/address-context/AddressContext.mjs";
import * as FareEstimateV2Helper$PorterinFeature from "../../../../../fare-estimate-v1/domain/helpers/FareEstimateV2Helper.mjs";
import * as FareEstimateContextV1$PorterinFeature from "../../../../../../contexts/fare-estimate-context/FareEstimateContextV1.mjs";
import * as OtpValidationFormState$PorterinFeature from "./OtpValidationFormState.mjs";
import * as OtpValidationModuleScss from "../../../styles/OtpValidation.module.scss";
import * as OtpValidationFormInterface$PorterinFeature from "./OtpValidationFormInterface.mjs";

var styles = OtpValidationModuleScss;

function OtpValidationFormCmp(Props) {
  var close_modal = Props.close_modal;
  var close_on_successOpt = Props.close_on_success;
  var close_on_success = close_on_successOpt !== undefined ? close_on_successOpt : true;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var agreed_docs = match$1.agreed_docs;
  var set_user = match$1.set_user;
  var user = match$1.user;
  var set_is_authenticated = match$1.set_is_authenticated;
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsSubmitting = match$2[1];
  var match$3 = React.useState(function () {
        return true;
      });
  var setIsFieldEmpty = match$3[1];
  var router = Router.useRouter();
  var match$4 = AddressContext$PorterinFeature.useAddressContext(undefined);
  var receiver = match$4.receiver;
  var sender = match$4.sender;
  var match$5 = FareEstimateContextV1$PorterinFeature.useFareEstimateContext(undefined);
  var selected_vehicle = match$5.selected_vehicle;
  var match$6 = React.useState(function () {
        return OtpValidationFormState$PorterinFeature.initialFormState(undefined);
      });
  var setInitialInput = match$6[1];
  var match$7 = React.useState(function () {
        
      });
  var setResponse = match$7[1];
  var response = match$7[0];
  var form = OtpValidationFormInterface$PorterinFeature.Form.useForm(match$6[0], (function (output, callbacks) {
          var redirection_url = router.pathname === "/fare-estimate" ? FareEstimateV2Helper$PorterinFeature.orderReviewLinkCreator(sender, receiver, selected_vehicle, user) : "";
          OtpValidationFormState$PorterinFeature.onFormSubmit(close_on_success, output, callbacks, setResponse, close_modal, user, set_user, set_is_authenticated, redirection_url, router, agreed_docs);
        }));
  var getFieldError = function (field) {
    Curry._1(form.dirty, undefined);
    return CommonHelper$PorterinFeature.getError(field);
  };
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG === /* Submitting */0) {
            Curry._1(setIsSubmitting, (function (param) {
                    return true;
                  }));
          } else {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setIsSubmitting, (function (param) {
                    return false;
                  }));
            Curry._1(setInitialInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  var match$8 = Curry._1(form.dirty, undefined);
  var tmp;
  tmp = response !== undefined && !(response.TAG === /* Ok */0 || match$8) ? React.createElement("div", {
          className: styles["submit-button-error"]
        }, response._0) : null;
  return React.createElement("form", {
              className: styles["otp-validation-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement("div", {
                  className: styles["field-wrapper"]
                }, React.createElement(AuthInputCmp$PorterinFeature.make, {
                      label: AuthStore$PorterinFeature.OtpValidation.input_placeholder,
                      is_required: true,
                      is_filled: match$3[0],
                      children: React.createElement("input", {
                            className: styles["mobile-input"],
                            autoFocus: true,
                            disabled: form.submitting,
                            maxLength: 6,
                            placeholder: "",
                            type: "tel",
                            value: form.input.otp,
                            onBlur: (function (param) {
                                Curry._1(form.blurOtp, undefined);
                              }),
                            onChange: (function ($$event) {
                                Curry._1(setIsFieldEmpty, (function (param) {
                                        return $$event.target.value.length === 0;
                                      }));
                                Curry._2(form.updateOtp, (function (_input, value) {
                                        return {
                                                otp: value
                                              };
                                      }), $$event.target.value);
                              })
                          }),
                      error: getFieldError(form.otpResult),
                      styles: styles.style
                    })), React.createElement("div", {
                  className: styles["submit-button-wrapper"]
                }, React.createElement(AuthButtonCmp$PorterinFeature.make, {
                      is_disabled: !Curry._1(form.valid, undefined) || form.submitting,
                      is_submitting: match$2[0],
                      class_name: styles["submit-container"],
                      event_name: AuthStore$PorterinFeature.OtpValidation.ga_form_submit_event,
                      category: match.category,
                      submit_text: AuthStore$PorterinFeature.OtpValidation.submit_button,
                      event_label: undefined,
                      mobile: AuthUtils$PorterinFeature.mobile(user)
                    }), tmp));
}

var make = OtpValidationFormCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
